/** App role identifiers (company-scoped via getUserInfo / userCompanyMapping). */
export const ROLE = {
    RL_ADMIN_VIEW: {
        id: 5,
        roleName: 'RL Admin View',
    },
    RL_BILLING_ADMIN: {
        roleName: 'RL Billing Admin',
    },
} as const;

export type AppRole = {
    id?: number;
    roleName?: string;
};
